import { useSelector } from 'react-redux'
import styles from '../InternalExternalDetail.module.css'
import SectionHeader from './SectionHeader'
import EduCard from './EduCard'

const CertificationSection = ({ mode }) => {
  const rawData = useSelector((state) => state.externalUserDetailReducer.rawData)
  const userSchema = useSelector(
    (state) => state.oneUserskillListingReducer?.skillListings?.user_Schema?.Profiles?.Consultants_Certificates
  )

  const certifications = mode === 'external'
    ? (Array.isArray(rawData?.certifications)
        ? rawData.certifications.map((cert) => ({
            title: cert.name,
            meta: cert.authority,
            year: cert.end_date_year
              ? `${cert.start_date_year} - ${cert.end_date_year}`
              : `${cert.start_date_year}`,
          }))
        : [])
    : (Array.isArray(userSchema)
        ? userSchema
            .filter((cert) => !cert.Deleted)
            .map((cert) => ({
              title: cert.Description,
            }))
        : [])

  if (!certifications.length) return null

  return (
    <section className={styles.card}>
      <SectionHeader title="Certification" />
      <div className={styles.educationGrid}>
        {certifications.map((item, index) => (
          <EduCard
            key={index}
            title={item.title}
            meta={item.meta}
            year={item.year}
            iconName="briefcase"
          />
        ))}
      </div>
    </section>
  )
}

export default CertificationSection
